module.exports = __webpack_public_path__ + "static/media/keyboard.76b5c4c4.svg";